export * from "./DocumentPageLink";
